import { ThreeSixtySavingsDto } from '../api/dto/three-sixty-savings.dto'
import { ThreeSixtySavings } from '../types'
import moment from '@e3dc-react/shell/Libs/moment'

/**
 * Transformer to transform api data to useable data for frontend
 */
const ThreeSixtySavingsToModelTransformer = (values: ThreeSixtySavingsDto[]): ThreeSixtySavings[] => {
  return values.map((id, index) => ({
    time: moment(values[index].time),
    netOutWh: values[index].netOutWh || 0,
    savings: values[index].savings || 0,
    weightedPrice: values[index].weightedPrice || 0,
  }))
}

export default ThreeSixtySavingsToModelTransformer
